module.exports = __webpack_public_path__ + "static/media/AW_rootbeer_hero_mobile_fr.fc6fc5a8.jpg";